import { Directive } from "@angular/core";

@Directive({
	selector: "[tgToolbarHeader]",
})
export class TgToolbarHeaderDirective {
	constructor() {}
}
